// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterBtn_root__jnH7_","isActive":"FilterBtn_isActive__a4yjX","icon":"FilterBtn_icon__1NzgI"};